<template>
  <div class="tensions-view">
    <!--  <Component /> -->
  tensions


  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'TensionsView',
  components: {
//    'GroupsView': () => import('@/views/holon/GroupsView'),

  },
}
</script>
<style>
.users-view {
  text-align: left;
}
</style>
